import { Component, OnInit } from '@angular/core';
import { ColmecWorkingOrderStepComponent } from '../colmec-working-order-step/colmec-working-order-step.component';
import { ColmecPartnerAgreementsService } from '../../../../services/colmec-partner-agreements.service';
import { SelectedCustomerService, CustomerService, MetadataService } from 'gung-standard';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { first, switchMap, of, forkJoin } from 'rxjs';
import { OptionsList, OptionsListMulti } from 'gung-common';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'colmec-working-order-basic-info-step',
    templateUrl: './colmec-working-order-basic-info-step.component.html',
    styleUrls: ['./colmec-working-order-basic-info-step.component.scss'],
    standalone: false
})
export class ColmecWorkingOrderBasicInfoStepComponent extends ColmecWorkingOrderStepComponent implements OnInit {
  public form: FormGroup;

  public partnerAgreementOptionsList: OptionsList[] = [];
  public reasonForWorkOptionsList: OptionsListMulti[] = [];

  constructor(
    protected selectedCustomerService: SelectedCustomerService,
    protected colmecPartnerAgreementsService: ColmecPartnerAgreementsService,
    protected customerService: CustomerService,
    protected metadataService: MetadataService,
    protected translateService: TranslateService
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.onNextBtnClicked.subscribe(_ => this.handleNextButtonClicked());
    this.onPreviousBtnClicked.subscribe(_ => this.handlePreviousButtonClicked());
    this.initForm();
    this.getPartnerAgreementData();
    this.getReasonForWorkData();
  }

  public getLabel(): string {
    return 'BASIC_INFO';
  }

  private handleNextButtonClicked(): void {
    if (!this.form.valid) {
      this.form.markAsDirty();
      this.form.markAllAsTouched();
      return;
    }

    const rawForm = this.form.getRawValue();

    this.workingOrder = {
      ...this.workingOrder,
      ...rawForm
    };

    this.stepDone.emit(this.workingOrder);
  }

  private handlePreviousButtonClicked(): void {
    const rawForm = this.form.getRawValue();

    this.workingOrder = {
      ...this.workingOrder,
      ...rawForm
    };

    this.stepPrevious.emit(this.workingOrder);
  }

  private initForm(): void {
    this.form = new FormGroup({
      agreementId: new FormControl(this.workingOrder.agreementId || '', [Validators.required]),
      workPerformedDate: new FormControl(this.workingOrder.workPerformedDate, [Validators.required]),
      regNr: new FormControl(this.workingOrder.regNr || '', [Validators.required]),
      reasonForWork: new FormControl(this.workingOrder.reasonForWork || [], [Validators.required]),
      extra: new FormGroup({
        comment: new FormControl(this.workingOrder?.extra?.comment || '')
      })
    });
  }

  private getPartnerAgreementData(): void {
    this.partnerAgreementOptionsList = [];

    this.selectedCustomerService.getSelectedCustomer().pipe(
      first(),
      switchMap(selectedCustomer => forkJoin({
        selectedCustomer: of(selectedCustomer),
        partnerAgreements: this.colmecPartnerAgreementsService.getPartnerAgreementsInternal(true).pipe(first())
      }))
    ).subscribe(({ selectedCustomer, partnerAgreements }) => {
      const partnerAgreementsFiltered = partnerAgreements.filter(pa => pa.partnerId === selectedCustomer.id && pa.status === 'ACTIVE');
      for (const pa of partnerAgreementsFiltered) {
        let name: string = '';

        name += `${pa.customerName} (${pa.customerId}) - `;

        name += `${pa.partnerName} (${pa.partnerId})`;

        this.partnerAgreementOptionsList.push({
          id: pa.id || pa.partnerId,
          name: name
        });
      }
    });
  }

  private getReasonForWorkData(): void {
    const workingOrderReasonsMetadata = this.metadataService.getMetadataTableList('WORKING_ORDER_REASONS');

    const reasons: OptionsListMulti[] = workingOrderReasonsMetadata.map(r => {
      return {
        id: r.id,
        name: this.translateService.instant(r.name || ''),
        selected: false
      }
    });

    for (const option of reasons) {
      if (this.workingOrder.reasonForWork.includes(option.id)) {
        option.selected = true;
      }
    }

    this.reasonForWorkOptionsList = reasons;
  }
}
